import React from 'react'
import { useTranslation } from 'react-i18next'
import InsightViewOption, { InsightViewOptionStrings } from 'enums/InsightViewOption'
import messageUtil from 'utils/messageUtil'

const Title = ({
  viewOption,
  isForAllTopics
}: {
  viewOption: InsightViewOptionStrings
  isForAllTopics: boolean
}) => {
  const { t } = useTranslation()

  let title = ''

  if (isForAllTopics) {
    title = t('totalMetricForAllTopics', { metric: messageUtil.viewOption(viewOption) })
    if (viewOption === InsightViewOption.ENGAGEMENTS) {
      title = t('totalEngagementsForAllTopics')
    }
  } else {
    title = t('totalMetric', { metric: messageUtil.viewOption(viewOption) })
    if (viewOption === InsightViewOption.ENGAGEMENTS) {
      title = t('totalEngagement_other')
    }
  }

  return <div>{title}</div>
}

export default Title
